import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { RouteId } from 'app/enums/env/routes-id-enum';
import { MainRoute } from 'app/models/MainRoute';
import { FeatureState } from 'app/store';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    TranslateModule,
    TooltipModule,
  ],
})
export class NavigationItemComponent {
  @Input() isLoggedIn = true;
  @Input() route!: MainRoute;
  @Input() isExpanded = true;
  @Input() toggleFeatureView!: FeatureState; // Use for toggle feature

  public routeId = RouteId;
  public opened = true;


}
